import { LmIconFilledHardwareMonitor, LmIconOutlineHardwareMonitor } from '@mes-ui/lemma/icons';

import { WidgetIconProps } from '../types';

const IconCultureOnlineEventsCommon = ({ iconType, ...rest }: WidgetIconProps) =>
  iconType === 'outlined' ? <LmIconOutlineHardwareMonitor {...rest} /> : <LmIconFilledHardwareMonitor {...rest} />;

export default IconCultureOnlineEventsCommon;
